import { useEffect } from 'react';

import { Text, Title } from '@mantine/core';

export interface PageTitleProps {
  title: string;
  subtitle?: string;
}

export function PageTitle({ title, subtitle }: Readonly<PageTitleProps>) {
  useEffect(() => {
    document.title = 'GTI Hub | Ground Truth Intelligence';
  }, []);

  return (
    <div>
      <Title order={2} c="var(--mantine-color-navy)">
        {title}
      </Title>
      {subtitle && (
        <Text size="sm" c="var(--mantine-color-dimmed)">
          {subtitle}
        </Text>
      )}
    </div>
  );
}
